export default "__VITE_ASSET__gM0$atmh__"